import gpo1 from "../assets/HeroCarouselImages/DGPPO.jpg";
import gpo2 from "../assets/HeroCarouselImages/gpo.jpeg";
import gpo3 from "../assets/HeroCarouselImages/mur.jpg";
import blind from "../assets/ServicesSectionImages/literature.png";
import coin from "../assets/ServicesSectionImages/coin.png";
import letter from "../assets/ServicesSectionImages/letter.png";
import letter2 from "../assets/ServicesSectionImages/letter.png";
import parcel from "../assets/ServicesSectionImages/news.png";
import parcel2 from "../assets/ServicesSectionImages/parcel.png";
import ems from "../assets/ServicesSectionImages/ems plus.png";
import emsplus from "../assets/ServicesSectionImages/ems plus-2.jpg";
import termcondition from "../assets/ServicesSectionImages/terms.png";
import inspection from "../assets/ServicesSectionImages/inspection.png";
import prohibited from "../assets/ServicesSectionImages/prohibited.png";
import insurance from "../assets/ServicesSectionImages/insurance.png";
import postbox from "../assets/ServicesSectionImages/postbox.png";
import registeration from "../assets/ServicesSectionImages/registeration.png";
import paypost from "../assets/ServicesSectionImages/paypost.png";
import certificate from "../assets/ServicesSectionImages/certificate.png";
import recall from "../assets/ServicesSectionImages/recall.png";
import postres from "../assets/ServicesSectionImages/postres.png";
import packets from "../assets/ServicesSectionImages/smallpackets.png";
import cod from "../assets/ServicesSectionImages/cod.png";
import fax from "../assets/ServicesSectionImages/fax.png";
import faxmoney from "../assets/ServicesSectionImages/money.png";
import printedpaper from "../assets/ServicesSectionImages/printedpapers.png";
import urgent from "../assets/ServicesSectionImages/urgentmoney.png";
import emo from "../assets/ServicesSectionImages/emo.png";
import remittance from "../assets/ServicesSectionImages/remittence.png";

import ordinaryletterpdf from "../assets/ServicesPDF/Mail Services/Domestic Services/Traditional Services/Ordinary Mail.pdf";
import printedpaperpdf from "../assets/ServicesPDF/Mail Services/Domestic Services/Traditional Services/Printed Papers.pdf";
import literatureforblindpdf from "../assets/ServicesPDF/Mail Services/Domestic Services/Traditional Services/Literature For Blind.pdf";
import smallpacketspdf from "../assets/ServicesPDF/Mail Services/Domestic Services/Traditional Services/Small Packets.pdf";
import newspaperpdf from "../assets/ServicesPDF/Mail Services/Domestic Services/Traditional Services/NewsPaper.pdf";
// // import CertificateOfPostingpdf from "../assets/ServicesPDF/Mail Services/Domestic Services/Miscellaneous Services/Certificate Of Posting.pdf"
// // import RecallOfPostedArticlespdf from "../assets/ServicesPDF/Mail Services/Domestic Services/Miscellaneous Services/Recall Of Posted Articles.pdf"
// // import PostRestantepdf from "../assets/ServicesPDF/Mail Services/Domestic Services/Miscellaneous Services/Post Restante.pdf"
// // import ValuePayablePostpdf from "../assets/ServicesPDF/Mail Services/Domestic Services/Miscellaneous Services/Value Payable Post.pdf"
// // import PostBoxesAndBagspdf from "../assets/ServicesPDF/Mail Services/Domestic Services/Miscellaneous Services/Post Boxes And Bags.pdf"
// // import Registrationpdf from "../assets/ServicesPDF/Mail Services/Domestic Services/Value Added Services/Registration.pdf"
// // import Insurancepdf from "../assets/ServicesPDF/Mail Services/Domestic Services/Value Added Services/Insurance.pdf"
// // import Letterpdf from "../assets/ServicesPDF/Mail Services/International Services/Letter.pdf"
// // import Parcelpdf from "../assets/ServicesPDF/Mail Services/International Services/Parcel.pdf"
// // import ExpressMailServicepdf from "../assets/ServicesPDF/Mail Services/International Services/Express Mail Service.pdf"
// // import ExpressMailServicePluspdf from "../assets/ServicesPDF/Mail Services/International Services/Express Mail Service Plus.pdf"
// // import TermsAndConditionspdf from "../assets/ServicesPDF/Mail Services/International Services/Terms And Conditions.pdf"
// // import CustomInspectionpdf from "../assets/ServicesPDF/Mail Services/International Services/Custom Inspection.pdf"
// // import ProhibitedItemspdf from "../assets/ServicesPDF/Mail Services/International Services/Prohibited Items.pdf"
// // import UrgentMailServicepdf from "../assets/ServicesPDF/Express Services/UMS/Urgent Mail Service.pdf"
// // import CounterCollectionpdf from "../assets/ServicesPDF/Mail Services/Express Services/UMS/Counter Collection.pdf"
// // import UrgentMailServiceRatespdf from "../assets/ServicesPDF/Mail Services/Express Services/UMS/Urgent Mail Service Rates.pdf"
// // import UMSCashOnDeliverypdf from "../assets/ServicesPDF/Mail Services/Express Services/UMS/UMS Cash on Delivery.pdf"
// // import UrgentMoneyOrderpdf from "../assets/ServicesPDF/Mail Services/Express Services/Urgent Money Order.pdf"
// // import FaxMoneyOrderpdf from "../assets/ServicesPDF/Mail Services/Express Services/Fax Money Order.pdf"
// // import FaxMailpdf from "../assets/ServicesPDF/Mail Services/Express Services/Fax Mail.pdf"
// // import ElectronicMoneyOrderpdf from "../assets/ServicesPDF/Mail Services/Express Services/Electronic Money Order.pdf"
// // import Remittancepdf from "../assets/ServicesPDF/Mail Services/Express Services/Remittance.pdf"

export const navlinks = [
  {
    id: 1,
    text: "Home",
    url: "/testppo/",
  },
  {
    id: 2,
    text: "Services",
    url: "/services",
  },
  {
    id: 3,
    text: "News",
    url: "/news",
  },
  {
    id: 4,
    text: "Tender",
    url: "/tender",
  },
  {
    id: 5,
    text: "About",
    url: "/about",
  },
  {
    id: 6,
    text: "Contact",
    url: "/contact",
  },
  {
    id: 7,
    text: "Stamps",
    url: "/stamps",
  },
];

export const Hero_Section_Pics = [
  {
    index: 1,
    image: gpo1,
  },
  {
    index: 2,
    image: gpo2,
  },
  {
    index: 3,
    image: gpo3,
  },
];

export const Questions = [
  {
    id: 1,
    question: "What is prohibited to be transmitted by the post?",
    answer:
      "Anything which is sent in contravention of any  enactment or government orders. An indecent or obscene printing, painting, photograph, lithograph, engraving, book, or card or any other indecent or obscene articles.",
    link1: "Prohibited Items List 1",
    link2: "Prohibited Items List 2",
    link3: "Prohibited Items List for International Mail",
  },
  {
    id: 2,
    question: "What is International Reply Coupon?",
    answer:
      "International Reply Coupons enable a sender of a letter to prepay a reply in any member country of the Universal Postal Union. A sender could enclose these coupons in the letter, which on receipt could be presented by addressee on the postal counter for receipt of the postage stamp.",
  },
  {
    id: 3,
    question: "What happens to an undeliverable article?",
    answer:
      "An article with an incomplete or ineligible address is consigned to Returned Letter Office, while article of an unknown addressee is either redirected in case fresh address is known or kept in deposit for seven days before sending it back to sender or to the Returned Letter Office.",
  },
  {
    id: 4,
    question: "Can I send articles of value in ordinary letter?",
    answer:
      "No Coin, bullion, precious stones, jewellery, currency notes and articles of gold or silver may only be sent, by the inland post insured. They may be sent by the foreign insured parcel post and can also be sent by the foreign letter post only in registered letters.",
  },
  {
    id: 5,
    question:
      "What happens to unpaid and insufficiently paid inland and foreign letters?",
    answer:
      "An inland letter posted unpaid is charged on delivery with double the postage and letter insufficiently prepaid is charged on delivery with double the amount of the deficiency. Similarly unpaid and insufficiently paid letters posted in Pakistan for transmission to a foreign country are returned to senders if their addresses can be easily ascertained.",
  },
  {
    id: 6,
    question: "What is Universal Postal Union?",
    answer:
      "Almost all the countries of the world have joined together into a union, known as the Universal Postal Union to regulate the postal services amongst them.",
  },
  {
    id: 7,
    question: "How can I avail Window delivery service?",
    answer:
      "This service is available in non post box areas. An addressee could receive all letters and other postal articles at the window of a post office, free of any charge during working hours. Addressee, however, has to request this facility in writing.",
  },
  {
    id: 8,
    question: "What is a Despatch Note?",
    answer:
      "Despatch note is a document to be presented with a parcel addressed to a foreign country. Despatch Note is available at the post office counter free of charge. Sender is required to enter his name and address as well the name and address of addressee in the despatch note. Rest of the entries in the despatch note is to be made by the postal official at the counter.",
  },
  {
    id: 9,
    question: " How can I obtain advice of delivery of my foreign parcel?",
    answer:
      "The sender of a parcel addressed to any parcel union country as well as to non parcel union country can obtain an advice of its delivery by paying a nominal fee. After the delivery of parcel the advice of delivery card is returned duly completed, to the sender by the office of destination.",
  },
  {
    id: 10,
    question: "Where could I get commemorative stamps?",
    answer:
      "Special arrangements exist at Philatelic Bureaus and Philatelic Counters operating in all general  post offices for the sale of commemorative and special series of postage stamps and first day of issue covers and brochures to philatelists.",
  },
  {
    id: 11,
    question: "Could I open account from overseas?",
    answer:
      "Yes, subject to the government rules, Pakistan nationals residing abroad may open an account directly or through their bankers or agents.",
  },
  {
    id: 12,
    question: "Is transfer of account allowed?",
    answer:
      "A depositor may have his account transferred, free of charge to any post office that is a saving bank provided that the account shall have been in existence for at least three months from the date on which it was opened.",
  },
];
// Domestic services starting
export const TraditionalServices = [
  {
    id: 1,
    title: "Letter & Post Card",
    description: "Ordinary Letters, Post Card, Envelopes and Aerogrammes",
    icon: letter,
    pdfPath: ordinaryletterpdf,
  },
  {
    id: 2,
    title: "Printed Papers",
    description: "Text Books & Other than Text Books",
    icon: printedpaper,
    pdfPath: printedpaperpdf,
  },
  {
    id: 3,
    title: "Literature For Blind",
    description:
      "Transmission of blind literature packets any kind, periodicals and books impressed in Braille",
    icon: blind,
    pdfPath: literatureforblindpdf,
  },
  {
    id: 4,
    title: "Small Packets",
    description:
      "Pak Post supports small businesses with affordable shipping for trade patterns and merchandise samples",
    icon: packets,
    pdfPath: smallpacketspdf,
  },
  {
    id: 5,
    title: "Register Newspapers & Parcels  ",
    description:
      "Pak Post facilitates delivery of news papers all over Pakistan at exceptionally low rates.",
    icon: parcel,
    pdfPath: newspaperpdf,
  },
  {
    id: 6,
    title: "Envellops ",
    description:
      "Pak Post facilitates delivery of news papers all over Pakistan at exceptionally low rates.",
    icon: parcel,
    pdfPath: newspaperpdf,
  },
];
export const MiscellaneousServices = [
  {
    id: 1,
    title: "Certificate Of Posting",
    description:
      "Pak Post assures mail posting via certificates, nominal fee charged.",
    icon: certificate,
  },
  {
    id: 2,
    title: "Recall of Posted Articles",
    description:
      "Sender-requested postal article recall aids reconsideration, preserving relationships from impulsivity.",
    icon: recall,
  },
  {
    id: 3,
    title: "Post Restante",
    description:
      "Poste Restante serves transient postal needs, limited to three months.",
    icon: postres,
  },
  {
    id: 4,
    title: "Value Payable Post",
    description:
      "Value-payable system caters to pay-on-receipt and recovery needs.",
    icon: paypost,
  },
  {
    id: 5,
    title: "Post Boxes and Bags",
    description:
      "Pak Post provides post box rental for prepaid mail in urban areas.",
    icon: postbox,
  },
  {
    id: 6,
    title: "Registration",
    description:
      "Registration enhances article security during postal transmission, applying special precautions.",
    icon: registeration,
  },
  {
    id: 7,
    title: "Insurance",
    description:
      "Insurance safeguards articles during transmission; covers registered mail, valuables, gold, currency.",
    icon: insurance,
  },
];
// Domestic services Ending
export const InternationalServices = [
  {
    id: 1,
    title: "Letter",
    description:
      "Efficient international letter delivery with reliable global connectivity and tracking.",
    icon: letter2,
    // pdfPath:letterpdf,
  },
  {
    id: 2,
    title: "Parcel",
    description:
      "Seamless global parcel service, ensuring secure international delivery and tracking.",
    icon: parcel2,
  },
  {
    id: 3,
    title: "Express Mail Service",
    description:
      "Swift international express mail, ensuring rapid delivery with reliable tracking.",
    icon: ems,
  },
  {
    id: 4,
    title: "Express Mail Service Plus",
    description:
      "Enhanced express mail with added features for swift international delivery.",
    icon: emsplus,
  },
  {
    id: 5,
    title: "Terms & Conditions ",
    description:
      "Clear guidelines outlining terms and conditions for seamless transactions.",
    icon: termcondition,
  },
  {
    id: 6,
    title: "Custom Inspection ",
    description:
      "Thorough examination ensuring compliance with customs regulations for international shipments.",
    icon: inspection,
  },
  {
    id: 7,
    title: "Prohibited Items",
    description:
      "Restricted goods not allowed for international shipping due to safety regulations.",
    icon: prohibited,
  },
];
export const ExpressService = [
  {
    id: 1,
    title: "Urgent Mail Service",
    description: "Quick domestic deliveries with tracking ",
    icon: letter,
  },
  {
    id: 2,
    title: "Counter Collection",
    description:
      "In-person item pickup service for added convenience in express shipping.",
    icon: coin,
  },
  {
    id: 3,
    title: "Urgent Mail Service Rates",
    description:
      "Pricing details for fast and efficient urgent mail delivery services.",
    icon: letter,
  },
  {
    id: 4,
    title: "UMS Cash on Delivery ",
    description:
      "Fast delivery with payment collection option for urgent mail services.",
    icon: cod,
  },
  {
    id: 5,
    title: "Urgent Money Order ",
    description:
      "Swift and secure money transfers through Urgent Money Order service.",
    icon: urgent,
  },
  {
    id: 6,
    title: "Fax Money Order",
    description:
      "Money transfer via fax for convenient and efficient transactions.",
    icon: faxmoney,
  },
  {
    id: 7,
    title: "Fax Mail",
    description:
      "Document transmission service using fax technology for quick communication.",
    icon: fax,
  },
  {
    id: 8,
    title: "Electronic Money Order ",
    description:
      "Digital payment method for secure and efficient money transfers.",
    icon: emo,
  },
  {
    id: 9,
    title: "Remittance",
    description:
      "Efficient international money transfer service for cross-border remittances.",
    icon: remittance,
  },
];
